document.getElementById('search-button').addEventListener('click', function() {
  var year = document.getElementById('year').value;
  var make = document.getElementById('make').value;
  var model = document.getElementById('model').value;

  // Build the query URL
  var query = '';
  if (year) query += 'year-' + year + '+';
  if (make) query += 'make-' + make + '+';
  if (model) query += 'model-' + model + '+';
  query = query.slice(0, -1); // Remove trailing '+'

  var url = '/search?type=product&q=' + encodeURIComponent(query);

  // Fetch products
  fetch(url)
    .then(response => response.text())
    .then(html => {
      document.getElementById('product-results').innerHTML = html;
    })
    .catch(error => {
      console.error('Error fetching products:', error);
    });
});
